export default "__VITE_ASSET__d7fd4124__"